import { createSlice } from '@reduxjs/toolkit';
import { getPaidSearch } from '../thunks/paidSearchThunk';

const paidSearchInitialData = {
    dtcData: {
        isPaidSearchLoading: false,
        totalReach: 0,
        totalEngagement: 0,
        totalCTR: 0,
        totalCost: 0,
        totalReachBarChart: {
            categories: [],
            data: []
        },
        totalEngagementBarChart: {
            categories: [],
            data: []
        },
        CTRBarChart: {
            categories: [],
            data: []
        },
        totalReachBarByCampaignChart: {
            categories: [],
            data: []
        },
        totalEngagementByCampaignBarChart: {
            categories: [],
            data: []
        },
        CTRBarByCampaignChart: {
            categories: [],
            data: []
        },
        CPCBarChart: {
            categories: [],
            data: []
        },
        topReachChart: {
            categories: [],
            data: []
        },
        topEngagementChart: {
            categories: [],
            data: []
        },
        topHeadingChart: {
            categories: [],
            data: []
        },
        topCTRChart: {
            categories: [],
            data: []
        },
        topHCPSearchChart: {
            categories: [],
            data: []
        },
        topSearchClicksChart: {
            categories: [],
            data: []
        },
        topAffiliationHCPChart: {
            categories: [],
            data: []
        },
        worstReachChart: {
            categories: [],
            data: []
        },
        worstEngagementChart: {
            categories: [],
            data: []
        },
        worstCTRChart: {
            categories: [],
            data: []
        },
        worstHCPSearchChart: {
            categories: [],
            data: []
        },
        worstSearchClicksChart: {
            categories: [],
            data: []
        }
    }
};
const paidSearch = createSlice({
    name: 'paidSearch',
    initialState: paidSearchInitialData,
    reducers: {
        resetToInitialState(state, action) {
            Object.assign(state, paidSearchInitialData);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPaidSearch.fulfilled, (state, action) => {
                state.dtcData.isPaidSearchLoading = false;
                const paidSearchData = action?.payload || {};
                // Tiles
                const tileData = paidSearchData?.tileData || {};
                state.dtcData.totalReach = formatNumber(
                    tileData?.totalReach || 0
                );
                state.dtcData.totalEngagement = tileData.totalEngagement;
                state.dtcData.totalCTR = tileData.totalCTR;
                state.dtcData.totalCost = formatNumber(
                    tileData?.totalCost || 0
                );
                // Total ReachBar Chart
                const totalReachBarChart =
                    action?.payload?.totalReachBarChart || [];
                let sortedTotalReach =
                    totalReachBarChart?.sort((a, b) =>
                        a.month.localeCompare(b.month)
                    ) || [];
                sortedTotalReach =
                    sortedTotalReach?.filter((item) => item.total > 0) || [];
                state.dtcData.totalReachBarChart.categories =
                    sortedTotalReach?.map((item) => item?.month) || [];
                state.dtcData.totalReachBarChart.data =
                    sortedTotalReach?.map((item) => item?.total) || [];

                // ====== TOTAL REACH Campaign======
                const totalReachCampgainBarChart =
                    action?.payload?.totalReachBarChart || [];

                const sortedTotalCampgainReach =
                    totalReachCampgainBarChart
                        ?.sort((a, b) => a.month.localeCompare(b.month))
                        ?.filter((item) => item.total > 0) || [];

                state.dtcData.totalReachBarByCampaignChart.categories =
                    sortedTotalCampgainReach?.map((item) => item?.month) || [];

                state.dtcData.totalReachBarByCampaignChart.data = [
                    {
                        name: 'Branded',
                        data: sortedTotalCampgainReach.map(
                            (item) => item.branded_count
                        )
                    },
                    {
                        name: 'Non-Branded',
                        data: sortedTotalCampgainReach.map(
                            (item) => item.non_branded_count
                        )
                    }
                ];

                // ====== TOTAL ENGAGEMENT Campaign======
                const totalEngagementByCampaignBarChart =
                    action?.payload?.totalEngagementBarChart || [];

                const sortedTotalEngagementByCampaign =
                    totalEngagementByCampaignBarChart
                        ?.sort((a, b) => a.month.localeCompare(b.month))
                        ?.filter((item) => item.total > 0) || [];

                state.dtcData.totalEngagementByCampaignBarChart.categories =
                    sortedTotalEngagementByCampaign?.map(
                        (item) => item?.month
                    ) || [];

                state.dtcData.totalEngagementByCampaignBarChart.data = [
                    {
                        name: 'Branded',
                        data: sortedTotalEngagementByCampaign.map(
                            (item) => item.branded_count
                        )
                    },
                    {
                        name: 'Non-Branded',
                        data: sortedTotalEngagementByCampaign.map(
                            (item) => item.non_branded_count
                        )
                    }
                ];

                // ====== CTR BAR Campaign======
                const CTRBarByCampaignChart =
                    action?.payload?.CTRBarChart || [];

                const sortedCTRBarByCampaign =
                    CTRBarByCampaignChart?.sort((a, b) =>
                        a.month.localeCompare(b.month)
                    )?.filter((item) => item.total > 0) || [];

                state.dtcData.CTRBarByCampaignChart.categories =
                    sortedCTRBarByCampaign?.map((item) => item?.month) || [];

                state.dtcData.CTRBarByCampaignChart.data = [
                    {
                        name: 'Branded',
                        data: sortedCTRBarByCampaign.map(
                            (item) => item.branded_count
                        )
                    },
                    {
                        name: 'Non-Branded',
                        data: sortedCTRBarByCampaign.map(
                            (item) => item.non_branded_count
                        )
                    }
                ];

                // Total totalEngagementBarChart
                const totalEngagementBarChart =
                    action?.payload?.totalEngagementBarChart || [];
                let sortedTotalEngagementBarChart =
                    totalEngagementBarChart?.sort((a, b) =>
                        a.month.localeCompare(b.month)
                    ) || [];
                sortedTotalEngagementBarChart =
                    sortedTotalEngagementBarChart?.filter(
                        (item) => item.total > 0
                    ) || [];
                state.dtcData.totalEngagementBarChart.categories =
                    sortedTotalEngagementBarChart?.map((item) => item?.month) ||
                    [];
                state.dtcData.totalEngagementBarChart.data =
                    sortedTotalEngagementBarChart?.map((item) => item?.total) ||
                    [];
                // Total CTRBarChart Chart
                const CTRBarChart = action?.payload?.CTRBarChart || [];
                let sortedCTRBarChart =
                    CTRBarChart?.sort((a, b) =>
                        a.month.localeCompare(b.month)
                    ) || [];
                sortedCTRBarChart =
                    sortedCTRBarChart?.filter((item) => item.total > 0) || [];
                state.dtcData.CTRBarChart.categories =
                    sortedCTRBarChart?.map((item) => item?.month) || [];
                state.dtcData.CTRBarChart.data =
                    sortedCTRBarChart?.map((item) => item?.total) || [];
                // Total CPCBarChart Chart
                const CPCBarChart = action?.payload?.CPCBarChart || [];
                let sortedCPCBarChart =
                    CPCBarChart?.sort((a, b) =>
                        a.month.localeCompare(b.month)
                    ) || [];
                sortedCPCBarChart =
                    sortedCPCBarChart?.filter((item) => item.count > 0) || [];
                state.dtcData.CPCBarChart.categories =
                    sortedCPCBarChart?.map((item) => item?.month) || [];
                state.dtcData.CPCBarChart.data =
                    sortedCPCBarChart?.map((item) => item?.count) || [];
                // top topReachChart
                const topReachChart = action?.payload?.topReachChart || [];
                const sortedTopReachChart =
                    topReachChart
                        ?.sort((a, b) => b.total - a.total)
                        .slice(0, 10) || [];
                state.dtcData.topReachChart.categories =
                    sortedTopReachChart?.map((item) => item?.name) || [];
                state.dtcData.topReachChart.data = sortedTopReachChart || [];

                // top topEngagementChart
                const topEngagementChart =
                    action?.payload?.topEngagementChart || [];
                const sortedTopEngagementChart =
                    topEngagementChart
                        ?.sort((a, b) => b.total - a.total)
                        .slice(0, 10) || [];
                state.dtcData.topEngagementChart.categories =
                    sortedTopEngagementChart?.map((item) => item?.name) || [];
                state.dtcData.topEngagementChart.data =
                    sortedTopEngagementChart || [];

                // top topHeadingChart
                const topHeadingChart = action?.payload?.topHeadingChart || [];
                const sortedTopHeadingChart =
                    topHeadingChart
                        ?.sort((a, b) => b.total - a.total)
                        .slice(0, 10) || [];
                state.dtcData.topHeadingChart.categories =
                    sortedTopHeadingChart?.map((item) => item?.name) || [];
                state.dtcData.topHeadingChart.data =
                    sortedTopHeadingChart || [];

                // top topCTRChart
                const topCTRChart = action?.payload?.topCTRChart || [];
                const sortedTopCTRChart =
                    topCTRChart
                        ?.sort((a, b) => b.totalPercentage - a.totalPercentage)
                        .slice(0, 10) || [];
                state.dtcData.topCTRChart.categories =
                    sortedTopCTRChart?.map((item) => item?.name) || [];
                state.dtcData.topCTRChart.data = sortedTopCTRChart || [];

                // top HCP search Chart
                const topHCPSearchChart =
                    action?.payload?.topHCPKeywordsChart || [];
                const sortedTopHCPSearchChart =
                    topHCPSearchChart
                        ?.sort((a, b) => b.total - a.total)
                        .slice(0, 10) || [];
                state.dtcData.topHCPSearchChart.categories =
                    sortedTopHCPSearchChart?.map((item) => item?.name) || [];
                state.dtcData.topHCPSearchChart.data =
                    sortedTopHCPSearchChart || [];

                // top search clicks Chart
                const topSearchClickChart =
                    action?.payload?.topTotalSearchKeywordsChart || [];
                const sortedTopSearchClickChart =
                    topSearchClickChart
                        ?.sort((a, b) => b.total - a.total)
                        .slice(0, 10) || [];
                state.dtcData.topSearchClicksChart.categories =
                    sortedTopSearchClickChart?.map((item) => item?.name) || [];
                state.dtcData.topSearchClicksChart.data =
                    sortedTopSearchClickChart || [];

                // top affiliation HCP Chart
                const topAffiliationHCPChart =
                    action?.payload?.topAffiliationChart || [];
                const sortedTopAffiliationHCPChart =
                    topAffiliationHCPChart
                        ?.sort((a, b) => b.total - a.total)
                        .slice(0, 10) || [];
                state.dtcData.topAffiliationHCPChart.categories =
                    sortedTopAffiliationHCPChart?.map((item) => item?.name) ||
                    [];
                state.dtcData.topAffiliationHCPChart.data =
                    sortedTopAffiliationHCPChart || [];

                // worst worstReachChart
                let worstReachChart = action?.payload?.worstReachChart || [];
                worstReachChart =
                    worstReachChart?.filter((item) => item.total > 0) || [];
                const sortedworstReachChart =
                    worstReachChart
                        ?.sort((a, b) => a.total - b.total)
                        .slice(0, 10) || [];
                state.dtcData.worstReachChart.categories =
                    sortedworstReachChart?.map((item) => item?.name) || [];
                state.dtcData.worstReachChart.data =
                    sortedworstReachChart || [];

                // worst worstEngagementChart
                let worstEngagementChart =
                    action?.payload?.worstEngagementChart || [];
                worstEngagementChart =
                    worstEngagementChart?.filter((item) => item.total > 0) ||
                    [];
                const sortedworstEngagementChart =
                    worstEngagementChart
                        ?.sort((a, b) => a.total - b.total)
                        .slice(0, 10) || [];
                state.dtcData.worstEngagementChart.categories =
                    sortedworstEngagementChart?.map((item) => item?.name) || [];
                state.dtcData.worstEngagementChart.data =
                    sortedworstEngagementChart || [];

                // worst worstCTRChart
                let worstCTRChart = action?.payload?.worstCTRChart || [];
                worstCTRChart =
                    worstCTRChart?.filter((item) => item.totalPercentage > 0) ||
                    [];
                const sortedworstCTRChart =
                    worstCTRChart
                        ?.sort((a, b) => a.totalPercentage - b.totalPercentage)
                        .slice(0, 10) || [];
                state.dtcData.worstCTRChart.categories =
                    sortedworstCTRChart?.map((item) => item?.name) || [];
                state.dtcData.worstCTRChart.data = sortedworstCTRChart || [];

                // worst HCP search Chart
                let worstHCPSearchChart =
                    action?.payload?.worstHCPKeywordsChart || [];
                worstHCPSearchChart =
                    worstHCPSearchChart?.filter((item) => item.total > 0) || [];
                const sortedWorstHCPSearchChart =
                    worstHCPSearchChart
                        ?.sort((a, b) => a.total - b.total)
                        .slice(0, 10) || [];
                state.dtcData.worstHCPSearchChart.categories =
                    sortedWorstHCPSearchChart.map((item) => item?.name) || [];
                state.dtcData.worstHCPSearchChart.data =
                    sortedWorstHCPSearchChart || [];

                // worst search clicks Chart
                let worstSearchClicksChart =
                    action?.payload?.worstTotalSearchKeywordsChart || [];
                worstSearchClicksChart =
                    worstSearchClicksChart?.filter((item) => item.total > 0) ||
                    [];
                const sortedWorstSearchClicksChart =
                    worstSearchClicksChart
                        ?.sort((a, b) => a.total - b.total)
                        .slice(0, 10) || [];
                state.dtcData.worstSearchClicksChart.categories =
                    sortedWorstSearchClicksChart?.map((item) => item?.name) ||
                    [];
                state.dtcData.worstSearchClicksChart.data =
                    sortedWorstSearchClicksChart || [];
            })
            .addCase(getPaidSearch.pending, (state, action) => {
                state.dtcData.isPaidSearchLoading = true;
            })
            .addCase(getPaidSearch.rejected, (state, action) => {
                state.dtcData.isPaidSearchLoading = false;
            });
    }
});
function formatNumber(value) {
    if (value >= 1_000_000) {
        return (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (value >= 1_000) {
        return (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return value.toString();
}
export const { actions } = paidSearch;
export default paidSearch.reducer;
